import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditForms from './EditForms'
import ModalHeader from './ModalHeader'

const EditFormModal = props => {
  return (
    <ControlledModal fullScreen noPadding {...props}>
      <ModalHeader />
      <PermissionChecker any={['createForm', 'editForm']}>
        <EditForms />
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditFormModal
